import {NullAsDefault} from "../views/Shared";

export function UseHook({
  hook,
                          initialValue,
  deps,
                          children = NullAsDefault
}) {
  const hooked = hook(initialValue, deps)
  return children(hooked)
}
